// React
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Redux
import { useSelector } from 'react-redux';

// Assets
import { CDN_LINK } from '../../../assets/img';

// Components
import { Link } from '@material-ui/core';

// CSS
import './styles.scss';

const HeaderLogin = (props) => {
  const { content, tenantConfig } = useSelector((state) => {
    return {
      content: state?.ContentReducer?.content,
      tenantConfig: state?.TenantConfigReducer?.tenantConfig
    };
  });
  const headerContent = content?.components?.header;
  return (
    <div className='header-login'>
      {tenantConfig?.header?.ribbon && (
        <div
          style={{
            backgroundImage: `url(${CDN_LINK}/${headerContent?.images?.ribbon_small?.image})`
          }}
          className='bosch-strip header-login__strip-small'
        />
      )}
      <div className='header-login__container'>
        <Link component={RouterLink} to='/' underline='none'>
          <img
            src={`${CDN_LINK}/${headerContent?.images?.logo?.image}`}
            alt=''
            title={headerContent?.images?.logo?.alt}
            className='bosch-logo'
          />
        </Link>
      </div>
    </div>
  );
};

export default HeaderLogin;
